import React, { useMemo } from 'react';
import { TextField, MenuItem } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import { hazardMetrics } from '../../store/constants/hazardAttrs';
import {
  selectHazardMetric,
  selectUseHurricaneApi,
} from '../../store/options/options.selector';
import { changeHazardMetric } from '../../store/options/options.slice';
import { changeEventDisplayVisible } from '../../store/ui/ui.slice';

import './metric-selector.styles.scss';

export default function MetricSelector() {
  const dispatch = useDispatch();
  const currentValue = useSelector(selectHazardMetric);
  const isDisabled = useSelector(selectUseHurricaneApi);

  const handleChange = (e) => {
    dispatch(changeEventDisplayVisible(false));
    dispatch(changeHazardMetric(e.target.value));
  };

  const metricOptions = useMemo(() => {
    return hazardMetrics.map(({ name, text }) => (
      <MenuItem key={name} value={name}>
        {text}
      </MenuItem>
    ));
  }, []);

  return (
    <div>
      <TextField
        select
        label='Impacts'
        variant='standard'
        value={currentValue}
        onChange={handleChange}
        disabled={isDisabled}
      >
        {metricOptions}
      </TextField>
    </div>
  );
}
